// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> price-brothers-rise -> four-six-penn-apartment-homes
// Generated: 2026-11-03T23:03:22.461Z
// Counts: 1 design, 88 content, 18 slot group, 5 collection binding, 7 section, 2 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Answers to Common Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover refined style one block from the historic Country Club Plaza at 46 Penn Apartment Homes. <a class=\"richtext-link\" href=\"/floor-plans\">One and two bedroom apartment homes</a> pair open layouts, hardwood flooring, and quartz kitchens with built-in wine coolers, creating spaces that feel polished from the moment you walk in.</p><p>Beyond your front door, <a class=\"richtext-link\" href=\"/amenities\">resort-style amenities</a> make it easy to relax, stay active, and entertain. Spend an afternoon at the saltwater pool, join a free weekly class in the fitness center, or gather with friends around the fire pit and alfresco kitchen. Whether you are unwinding on your balcony or heading out to explore the Plaza, 46 Penn Apartment Homes brings comfort and convenience together.</p><p>Explore 46 Penn Apartment Homes and discover what makes these Country Club Plaza apartments feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "VALUE",
    "customValue": "<p>46 Penn Apartment Homes connects you to shopping, dining, arts, and recreation throughout Kansas City. The Country Club Plaza, Jacob L. Loose Park, the Nelson-Atkins Museum of Art, and Uptown Theater are all nearby, while Saint Luke's Hospital and the University of Missouri-Kansas City (UMKC) are close to home.</p><p>With more than 150 shops and world-class restaurants within walking distance, there is always something new to discover.</p><p>Visit our <u>Neighborhood</u> page to see more of what's nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "2-bedrooms-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>2-Bedroom Apartments in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "2-bedrooms-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>2 Bedrooms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments on the Plaza in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Saltwater Pool, Fitness Center, Clubhouse &amp; More</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartment Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Start your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact 46 Penn Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Connect With Our Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>A Closer Look At Our Showcase Layout at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Floor Plan</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1 &amp; 2 Bedroom Apartments Near Country Club Plaza</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore 46 Penn Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>View photos of apartments and community spaces at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the 46 Penn Photo Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Country Club Plaza Apartments in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Elevated Living at 46 Penn Apartment Homes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover apartments with poolside cabanas in Garland, TX. Luxury living with resort-style amenities is waiting for you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Poolside Cabanas in Garland TX Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartment Site Map in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near UMKC and the Country Club Plaza</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Shopping, Dining, Parks &amp; More Near 46 Penn</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive Perks For Local Employees</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-intro.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Claim Your Benefits?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>University of Kansas Medical Center</p></li><li><p>St. Luke's Hospital</p></li><li><p>Cerner</p></li><li><p>Lockton</p></li><li><p>Polsinelli</p></li><li><p>KCUMB</p></li><li><p>UMKC</p></li><li><p>CBIZ</p></li><li><p>Black and Veatch</p></li><li><p>All Price Brothers Commercial Tenants</p></li><li><p>Burns &amp; McDonnell</p></li><li><p>KCPD</p></li><li><p>KCFD</p></li><li><p>Active Military</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments in Country Club Plaza, Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Dedicated Pet Areas at 46 Penn</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Unparalleled Plaza Living</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Review how <span data-type=\"field-token\" data-field=\"property_name\"></span> protects your personal information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Access your resident portal and community resources at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>See what residents say about life at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Tour Our Apartments Near Country Club Plaza in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule Your Visit to 46 Penn</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Comfortable, Sleek &amp; Modern</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Begin a New Era</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Explore The Neighborhood</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We appreciate your interest in&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours of 46 Penn Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Our 1 &amp; 2-Bedroom Apartments Online</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Make the most of your time at home with spaces designed for relaxation, wellness, work, and entertaining at 46 Penn Apartment Homes.</p><p>Take a swim in the tiered saltwater pool with an integrated waterfall and sun shelf, fire up the grill at the alfresco kitchen, or gather around the fire pit with lounge seating. Stay active with free weekly classes in the state-of-the-art fitness center, then unwind in the on-site massage therapy and tanning rooms.</p><p>The resident clubhouse offers an entertainment lounge with billiards, an entertainment-style kitchen, a 24-hour coffee bar, and a business center with a conference room. A reservable guest suite makes hosting easy, while garage parking with electric vehicle charging, elevator service, and 24-hour access control add everyday convenience to our luxury apartments on the Plaza in Kansas City.</p><p>Inside your <a class=\"richtext-link\" href=\"/floor-plans\">1 or 2-bedroom apartment home</a>, enjoy hardwood flooring, quartz countertops, stainless steel appliances, a built-in wine cooler, a full-size washer and dryer, and French doors that open to a private patio or balcony.</p><p>Explore the complete collection of community and apartment features above.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about 46 Penn Apartment Homes? Our leasing team can share information about <a class=\"richtext-link\" href=\"/floor-plans\">current availability</a>, lease options, pets, parking, <a class=\"richtext-link\" href=\"/amenities\">community features</a>, or an upcoming visit.</p><p>Give us a call, visit the leasing office, or complete the contact form below. We look forward to helping you learn more about 46 Penn Apartment Homes in Kansas City, MO.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find quick answers about applying, leasing, pets, parking, amenities, and resident services at 46 Penn Apartment Homes.</p><p>Don't see your question below? Our <a class=\"richtext-link\" href=\"/contact-us\">leasing team</a> is always ready to help.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions About 46 Penn Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a space that fits your life with one and two bedroom floor plans at 46 Penn Apartment Homes.&nbsp;</p><p>Layouts feature open-concept living areas, eight-foot French doors, and a private patio or balcony in every home. Kitchens feature quartz countertops, a stainless steel appliance package, and a built-in wine cooler. Hardwood flooring in the living and dining areas, recessed and pendant lighting, and a full-size washer and dryer add everyday comfort. Select floor plans also include kitchen islands, wet bars, built-in desks, soaking tubs, 11-foot ceilings, and Plaza views.</p><p>Whether you prefer an efficient one-bedroom layout or the extra room of a two-bedroom home, our Country Club Plaza apartments offer a variety of options to explore.&nbsp;</p><p>Browse available floor plans below to compare layouts, square footage, and current availability. When you find a space you love, <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour online</a> to see 46 Penn Apartment Homes in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture your day-to-day at 46 Penn Apartment Homes. Browse the gallery for a closer look at our Plaza apartments in Kansas City, MO, from <a class=\"richtext-link\" href=\"/amenities\">apartment interiors to community spaces and outdoor areas</a>.</p><p>See the details of our quartz countertop kitchens, hardwood floors, and French doors that open to private patios and balconies. Get a feel for the clubhouse lounge, fitness center, and spa rooms, then explore the saltwater pool, alfresco kitchen, and fire pit designed for time outside.</p><p>Photos are only the beginning. <a class=\"richtext-link\" href=\"/schedule-a-tour\">Schedule a tour</a> to experience 46 Penn Apartment Homes in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover what's around 46 Penn Apartment Homes from its prime location at 4551 Pennsylvania Avenue, one block from the historic Country Club Plaza. Shopping, dining, arts, and outdoor recreation are all part of everyday life here.</p><p>Browse 15 blocks of shops and more than 40 restaurants on the Country Club Plaza, including The Capital Grille, Cooper's Hawk Winery &amp; Restaurant, Jack Stack Barbecue, and Fogo de Chão. Spend an afternoon at Jacob L. Loose Park, explore the Nelson-Atkins Museum of Art, or catch a concert at Uptown Theater.</p><p>For anyone searching for apartments near UMKC, the University of Missouri-Kansas City campus is a short drive away, as is Kansas City University. Saint Luke's Hospital is right in the neighborhood, and KU Medical Center, Lockton, Hallmark, and Crown Center are easy to reach via Mill Creek Parkway and other major thoroughfares.</p><p>Explore the neighborhood map below to find more destinations near 46 Penn Apartment Homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets are welcome at 46 Penn Apartment Homes, with dedicated outdoor pet areas and membership in the Price Brothers Pet Royalty Club. Up to two pets are permitted per apartment. Monthly pet rent is $25 per pet, with a non-refundable pet fee of $300 for one pet or $500 for two pets. Breed restrictions apply.&nbsp;</p><p><a class=\"richtext-link\" href=\"/contact-us\">Contact the 46 Penn leasing team</a> for complete pet guidelines, restrictions, fees, and current policy information.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The non-refundable deposit is $300 for 1 pet, and $500 for 2 pets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exceptional Plaza Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience 46 Penn Apartment Homes beyond the screen. Schedule a guided tour to explore our apartments near Country Club Plaza in Kansas City, step inside available homes, and get a closer look at the <a class=\"richtext-link\" href=\"/amenities\">features</a> that matter most to you.</p><p>During your visit, you can explore <a class=\"richtext-link\" href=\"/floor-plans\">available layouts</a>, see the saltwater pool, fitness center, and clubhouse, and <a class=\"richtext-link\" href=\"/contact-us\">connect with the leasing team</a> to get answers to your questions.&nbsp;</p><p>Choose an available tour option and time below to plan your visit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_label": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Kansas City From 46 Penn Apartment Homes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a feel for 46 Penn Apartment Homes from anywhere. Virtually walk through our one and two bedroom apartments in Kansas City so you can see the finishes, flow, and spaces before you visit.</p><p>Look for hardwood flooring, quartz kitchens, French doors, and private patios or balconies as you explore each home.</p><p>Ready to see it in person? <a class=\"richtext-link\" href=\"/schedule-a-tour\">Schedule a tour</a> or <a class=\"richtext-link\" href=\"/floor-plans\">compare floor plans</a> to take the next step.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-9c16-7608-98a7-5fd2c550f645.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with island, stainless steel appliances, and dining area."
      }
    }
  },
  "hero.bg_image_2": {
    "sourceIndex": 5,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0d4c2-cc08-745c-b5d5-14f59e7268eb.webp"
      }
    }
  },
  "hero.bg_image_3": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0d4c2-d10b-724b-843a-dcbfd85d4432.webp"
      }
    }
  },
  "hero.bg_image_4": {
    "sourceIndex": 22,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0d4c2-cbae-74c1-95cf-53bb99672431.webp"
      }
    }
  },
  "hero.bg_image_5": {
    "sourceIndex": 15,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0d4c2-caf7-76ba-8545-8ca06b639c92.webp"
      }
    }
  },
  "hero.bg_image_6": {
    "sourceIndex": 25,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0d4c2-cba2-767b-a3a6-c28c71f73be4.webp"
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0d4cc-3d7f-72c0-92ce-7ecc0fbf8451.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of diverse women enjoying candlelit dinner, sharing laughter and wine indoors."
      }
    }
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-fc8f-7718-89fb-81c6daee3386.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept living and kitchen area in an apartment with a sofa, coffee table, TV, and kitchen island."
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-a4b3-7372-8cca-31f853d7c8cb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen with island and bar stools."
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-e1e8-732a-b9b1-a99d29387e5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and a sunset sky."
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-fdc6-7149-8d11-dcd4d43cbf59.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool and clubhouse at dusk"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-cf7a-714b-a066-6868f48ddfeb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and a building in the background at sunset."
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-de78-756a-9c1c-4ce39d139043.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior building entrance with a walkway lined with flowers and manicured bushes."
      }
    }
  },
  "tabbedcallouts.panel1_image": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "tabbedcallouts.panel2_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_7ac933fa-7eea-4271-8fb4-c600dcb0bb0e",
      "custom_656cbcf9-f880-45c1-9d2f-0e2e655e5e21",
      "custom_7efeaa8f-2352-4b3a-9d5f-61412018d6e8",
      "custom_169f81fe-33f8-4f6a-bf11-aaa2f89a3945",
      "custom_d06b7bdb-20a9-4862-a3ed-6a76df6016b5",
      "custom_565cfb78-b1c7-4220-adab-ff885e0186ad",
      "custom_3010d0a2-fb45-4200-9ecf-c17e9079d40b",
      "custom_9f7971bf-ca72-421d-847e-122d91841ea3",
      "custom_d6f0fc7d-ddaa-4145-9150-0f0ccafba80e",
      "custom_6152efe0-5f0e-4bd9-9eee-aa190d9d50c8",
      "custom_a6369a6d-761f-4733-942c-fee07fe0f7bd",
      "custom_eea4ddc2-45f7-4dda-8eca-84915f823177",
      "custom_67ca6c46-c9bb-4401-bd4e-580518f42991",
      "custom_b758db65-f8b5-45ec-8013-ab6bd73c7fbe",
      "custom_9a07f5f8-5d4f-42f7-a16b-f0c7de7b4364",
      "custom_08e6926e-f665-4504-83fa-c9c6f47630f0",
      "custom_e031328d-6d91-41b4-af24-af96c20869c6"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_273fb1b3-6599-49d7-854b-cbd142c74c28",
      "custom_19c9e8bf-8b47-49c4-8166-e9e209cfb55f",
      "custom_80dda726-a125-4910-93d0-3fba95705909",
      "custom_be060e99-c816-4895-b707-83db738dbf8a",
      "custom_92029215-8fc1-477e-8634-5c45ba93fefe",
      "custom_84ab720f-d959-4efc-85e1-f8b4440343dc",
      "custom_e5412399-727e-4f0d-b3b1-41e57073db24",
      "custom_56608524-6634-458b-899d-9cf5b67b5305",
      "custom_7cd9c3d0-57ef-40a3-a59a-af5ae5d44f27",
      "custom_946c9bbe-6f7f-4782-9262-6615a53a1ef8",
      "custom_57681438-52f9-464c-9bc7-1294d4637498",
      "custom_60b1ead1-8ce5-4902-9d0a-82a0182bd586",
      "custom_7d50b967-8e06-40a9-8e42-4c9b440f9932",
      "custom_f954b930-f733-426a-9030-047d2d6194a8",
      "custom_7be2e609-0a28-40d5-a6fe-09707e40aac8",
      "custom_10f74378-0126-4dce-930e-475f4caeb5e0",
      "custom_7405e890-cf6b-4b8d-979b-a0bd24dd3d68",
      "custom_1c32385c-0cc5-41ca-9c37-9d51039a9e1c",
      "custom_ca0fa59b-12ba-4fd2-ae9d-31ad80651b03",
      "custom_7d4e6d49-a31f-46ab-9eed-f024eb84ce64",
      "custom_3b3ecdbe-82b8-40f5-b040-6b9fb83e7237",
      "custom_7038a19b-bc80-448f-b407-deb4d71e73fb",
      "custom_e0fee789-c03c-4f5a-b130-8983cb1134a4",
      "custom_b4a4db3f-fbcc-4ed9-9f0a-0bc3d314c5ab",
      "custom_13117a67-c83e-4b1a-9958-21d85b6571d4",
      "custom_d49c931f-cf8b-4745-bf59-6bd78ec7e056",
      "custom_ee89ca95-fe77-4454-919a-85d3d67fb8ad",
      "custom_30df6437-93bb-4df0-9f9b-2c775e583228",
      "custom_4f5884ad-ee4d-49be-852b-6c85e089ca19",
      "custom_d0042a3b-8e35-4385-822a-a59d227f98c0",
      "custom_74b92109-0db8-4955-bde9-efed02657069",
      "custom_899d5400-4515-4046-8e34-725934d838bd",
      "custom_bcd10457-34e3-4276-86fb-0c571db472a0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "custom_08e6926e-f665-4504-83fa-c9c6f47630f0",
      "custom_6152efe0-5f0e-4bd9-9eee-aa190d9d50c8"
    ],
    "orderedIds": [
      "custom_7ac933fa-7eea-4271-8fb4-c600dcb0bb0e",
      "custom_67ca6c46-c9bb-4401-bd4e-580518f42991",
      "custom_7efeaa8f-2352-4b3a-9d5f-61412018d6e8",
      "custom_08e6926e-f665-4504-83fa-c9c6f47630f0",
      "custom_656cbcf9-f880-45c1-9d2f-0e2e655e5e21",
      "custom_b758db65-f8b5-45ec-8013-ab6bd73c7fbe",
      "custom_169f81fe-33f8-4f6a-bf11-aaa2f89a3945",
      "custom_a6369a6d-761f-4733-942c-fee07fe0f7bd",
      "custom_d06b7bdb-20a9-4862-a3ed-6a76df6016b5",
      "custom_3010d0a2-fb45-4200-9ecf-c17e9079d40b",
      "custom_eea4ddc2-45f7-4dda-8eca-84915f823177",
      "custom_e031328d-6d91-41b4-af24-af96c20869c6",
      "custom_565cfb78-b1c7-4220-adab-ff885e0186ad",
      "custom_9f7971bf-ca72-421d-847e-122d91841ea3",
      "custom_d6f0fc7d-ddaa-4145-9150-0f0ccafba80e",
      "custom_9a07f5f8-5d4f-42f7-a16b-f0c7de7b4364",
      "custom_6152efe0-5f0e-4bd9-9eee-aa190d9d50c8"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallerycommunity.images": {
    "limit": null,
    "hiddenIds": [
      "ec_b55254a10386b4df01eaa9b3",
      "custom_273fb1b3-6599-49d7-854b-cbd142c74c28",
      "custom_899d5400-4515-4046-8e34-725934d838bd",
      "custom_74b92109-0db8-4955-bde9-efed02657069",
      "custom_b4a4db3f-fbcc-4ed9-9f0a-0bc3d314c5ab",
      "custom_13117a67-c83e-4b1a-9958-21d85b6571d4",
      "custom_d49c931f-cf8b-4745-bf59-6bd78ec7e056",
      "custom_e0fee789-c03c-4f5a-b130-8983cb1134a4",
      "custom_ee89ca95-fe77-4454-919a-85d3d67fb8ad",
      "custom_4f5884ad-ee4d-49be-852b-6c85e089ca19"
    ],
    "orderedIds": [
      "custom_899d5400-4515-4046-8e34-725934d838bd",
      "custom_30df6437-93bb-4df0-9f9b-2c775e583228",
      "custom_d0042a3b-8e35-4385-822a-a59d227f98c0",
      "custom_7cd9c3d0-57ef-40a3-a59a-af5ae5d44f27",
      "custom_57681438-52f9-464c-9bc7-1294d4637498",
      "custom_946c9bbe-6f7f-4782-9262-6615a53a1ef8",
      "custom_60b1ead1-8ce5-4902-9d0a-82a0182bd586",
      "custom_4f5884ad-ee4d-49be-852b-6c85e089ca19",
      "custom_19c9e8bf-8b47-49c4-8166-e9e209cfb55f",
      "custom_84ab720f-d959-4efc-85e1-f8b4440343dc",
      "custom_74b92109-0db8-4955-bde9-efed02657069",
      "custom_273fb1b3-6599-49d7-854b-cbd142c74c28",
      "custom_10f74378-0126-4dce-930e-475f4caeb5e0",
      "custom_7405e890-cf6b-4b8d-979b-a0bd24dd3d68",
      "custom_92029215-8fc1-477e-8634-5c45ba93fefe",
      "custom_1c32385c-0cc5-41ca-9c37-9d51039a9e1c",
      "custom_13117a67-c83e-4b1a-9958-21d85b6571d4",
      "custom_56608524-6634-458b-899d-9cf5b67b5305",
      "custom_7038a19b-bc80-448f-b407-deb4d71e73fb",
      "custom_be060e99-c816-4895-b707-83db738dbf8a",
      "custom_e0fee789-c03c-4f5a-b130-8983cb1134a4",
      "custom_7d4e6d49-a31f-46ab-9eed-f024eb84ce64",
      "custom_7d50b967-8e06-40a9-8e42-4c9b440f9932",
      "custom_b4a4db3f-fbcc-4ed9-9f0a-0bc3d314c5ab",
      "custom_e5412399-727e-4f0d-b3b1-41e57073db24",
      "custom_ee89ca95-fe77-4454-919a-85d3d67fb8ad",
      "custom_7be2e609-0a28-40d5-a6fe-09707e40aac8",
      "custom_80dda726-a125-4910-93d0-3fba95705909",
      "custom_d49c931f-cf8b-4745-bf59-6bd78ec7e056",
      "custom_f954b930-f733-426a-9030-047d2d6194a8",
      "custom_ca0fa59b-12ba-4fd2-ae9d-31ad80651b03",
      "custom_3b3ecdbe-82b8-40f5-b040-6b9fb83e7237",
      "custom_bcd10457-34e3-4276-86fb-0c571db472a0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "hero.bg_images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "ec_b55254a10386b4df01eaa9b3",
      "ec_0000136d0a37439f8178e0fa",
      "ec_0ebbe2e8b7f9fa39bbc44b26",
      "ec_abeb4d2ff9762ae6308be26d",
      "ec_db58148b8fab79e979f7821f",
      "ec_0730d1b75850cc095ec09499",
      "ec_56c64ae5e9d8218814d28c23",
      "ec_95753e2d8d1ed6ae90c7522d",
      "ec_fd89359d82c8ee109e4ac431",
      "ec_1aadab4ea9f815bfdbbaad1e",
      "ec_f74fb00a31a1a2a30c8eb125",
      "ec_92a999f61b401a6c0b69cf6c",
      "ec_4a4194918b29da89545d3793",
      "ec_4c36e00b080a18068d237272",
      "ec_0cd50d6e5dfcda5938f54201",
      "ec_13f2103bb94fe4cceefd0985",
      "ec_8a282c7fee04877004cc78bd",
      "ec_02c2798c0512cb470ceea203",
      "ec_d0654ef13da82fea6d6bab0d",
      "ec_16fe2d925d59c0dfcb8406ce",
      "ec_390079eda7864d99bc5433fe",
      "ec_2934dd20171b72d7d2e31408",
      "ec_2bee92d17edf40e18b5b1252",
      "ec_1dd59256c72c65b8da497c12",
      "ec_9f7bc22294e48baab64737c7",
      "ec_134bc34bd37dfd2fe4df4db7",
      "ec_e86eb746acb0270bb3df0b35",
      "ec_9569392c2e0691424e1d8398",
      "ec_2a9cb71bb10cc41605b8cae8",
      "ec_49627739a544a396badf4c6a",
      "ec_a630c0895c9ff08340863e89",
      "ec_b2afab3c8c1a1a0e76886f05",
      "ec_3245d795d973eba89fd75ce6",
      "ec_e341658851d5222164895fca",
      "ec_f25f84263465a788aef76e78"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  },
  "propertyoverview.pre_title": {
    "properties": {
      "fontWeight": "600"
    }
  }
};
